import { useState } from 'react';
/* import { TabNotificaciones } from './TabNotificaciones';
 */import iconNoNot from './IconNoNot.svg';


export const NotificacionesHome = () => {

    return (
        <div className='p-container'>

            <h1 className='p-title'>Notificaciones</h1>

            <div className='mt-3'>
                <MenuModules />
            </div>

            <div className='flex flex-col items-center justify-center w-full h-full mt-10'>
                <div className='mt-10'>
                    <img src={iconNoNot} alt="No tienes notificaciones" />
                </div>
                <h2 className='text-center text-lg mt-10'>No tienes notificaciones pendientes de revisar.</h2>
            </div>

        </div >
    )
}


const MenuModules = () => {

    const [selectedMenu, setSelectedMenu] = useState('all');

    return (
        <>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">

                <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off"
                    checked={selectedMenu === 'all' && 'checked'}
                    onChange={() => setSelectedMenu('all')}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio1" style={{ color: selectedMenu === 'all' ? '#8E24AA' : '#595759' }}>
                    Todas
                </label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off"
                    checked={selectedMenu === 'today' && 'checked'}
                    onChange={() => setSelectedMenu('today')}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio2" style={{ color: selectedMenu === 'today' ? '#8E24AA' : '#595759' }}>
                    Tareas
                </label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off"
                    checked={selectedMenu === 'week' && 'checked'}
                    onChange={() => setSelectedMenu('week')}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio3" style={{ color: selectedMenu === 'week' ? '#8E24AA' : '#595759' }}>
                    Presupuestos
                </label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio4" autoComplete="off"
                    checked={selectedMenu === 'month' && 'checked'}
                    onChange={() => setSelectedMenu('month')}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio4" style={{ color: selectedMenu === 'month' ? '#8E24AA' : '#595759' }}>
                    Proyectos
                </label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio5" autoComplete="off"
                    checked={selectedMenu === 'range' && 'checked'}
                    onChange={() => setSelectedMenu('range')}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio5" style={{ color: selectedMenu === 'range' ? '#8E24AA' : '#595759' }}>
                    Cobranza
                </label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio6" autoComplete="off"
                    checked={selectedMenu === 'resumen' && 'checked'}
                    onChange={() => setSelectedMenu('resumen')}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio6" style={{ color: selectedMenu === 'resumen' ? '#8E24AA' : '#595759' }}>
                    Resumenes
                </label>

            </div>

            {/*  <div className='mt-4 p-text-date-year ms-1'>
                xxxxx
            </div> */}

        </>
    )

}